"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaucetClient = void 0;
const axios_1 = __importDefault(require("axios"));
class FaucetClient {
    constructor(baseUrl) {
        if (!baseUrl.match(/^https?:\/\//)) {
            throw new Error("Expected base url to start with http:// or https://");
        }
        // Strip trailing /
        const strippedBaseUrl = baseUrl.replace(/(\/+)$/, "");
        this.baseUrl = strippedBaseUrl;
    }
    async credit(address, denom) {
        const body = {
            address: address,
            denom: denom,
        };
        try {
            await axios_1.default.post(this.baseUrl + "/credit", body);
        }
        catch (error) {
            if (error.response) {
                // append response body to error message
                throw new Error(`${error}; response body: ${JSON.stringify(error.response.data)}`);
            }
            else {
                throw error;
            }
        }
    }
}
exports.FaucetClient = FaucetClient;
//# sourceMappingURL=faucetclient.js.map